import React, { useEffect, useState } from 'react';
import ProgressCircle from "../component/progresscircle";
import './LeaveApplications.css';

const LeaveApplications = () => {
  const [pendingLeaves, setPendingLeaves] = useState([]);
  const [historyLeaves, setHistoryLeaves] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("pending");

  // ✅ Load from localStorage
  useEffect(() => {
    const pending = JSON.parse(localStorage.getItem("pendingLeaves")) || [];
    const history = JSON.parse(localStorage.getItem("historyLeaves")) || [];

    setPendingLeaves(pending);
    setHistoryLeaves(history);
    setLoading(false);
  }, []);

  // ✅ Save to localStorage whenever data changes
  useEffect(() => {
    localStorage.setItem("pendingLeaves", JSON.stringify(pendingLeaves));
  }, [pendingLeaves]);

  useEffect(() => {
    localStorage.setItem("historyLeaves", JSON.stringify(historyLeaves));
  }, [historyLeaves]);

  // ✅ Approve / Reject
  const handleDecision = (id, status) => {
    const selected = pendingLeaves.find(l => l._id === id);
    if (!selected) return;

    const updatedLeave = {
      ...selected,
      status,
      actionAt: new Date().toISOString()
    };

    // remove from pending
    setPendingLeaves(prev => prev.filter(l => l._id !== id));

    // add to history
    setHistoryLeaves(prev => [updatedLeave, ...prev]);
  };

  if (loading) return <div className="la-loading">Loading leave applications…</div>;

  return (
    <>
      <div className="page-header-tap">
        <h3>Leave</h3>
        <div>
          <select className="select">
            <option>Export Excel</option>
            <option>Download PDF</option>
          </select>
          <button className="addbtn">+ Add Leave</button>
        </div>
      </div>

      <div className="counter-boxed-div">
        <ProgressCircle complete={80} full={130} label="Total Employee" />
        <ProgressCircle complete={20} full={130} label="Total Leave" />
        <ProgressCircle complete={4} full={12} label="Today Active" />
        <ProgressCircle complete={3} full={10} label="Today Absent" />
      </div>

      {/* Tabs */}
      <div style={{ marginTop: "20px" }}>
        <button
          className={activeTab === "pending" ? "tab active" : "tab"}
          onClick={() => setActiveTab("pending")}
        >
          Pending
        </button>
        <button
          className={activeTab === "history" ? "tab active" : "tab"}
          onClick={() => setActiveTab("history")}
        >
          History
        </button>
      </div>

      <div className="table-div" style={{ marginTop: '20px' }}>
        <div className="table-header">
          <h5>
            {activeTab === "pending"
              ? "Pending Leave Applications"
              : "Leave History"}
          </h5>
        </div>

        {/* Pending */}
        {activeTab === "pending" && (
          pendingLeaves.length === 0 ? (
            <div>No pending leave applications.</div>
          ) : (
            <div className="table">
              <table>
                <thead>
                  <tr>
                    <th>Employee</th>
                    <th>From</th>
                    <th>To</th>
                    <th>Reason</th>
                    <th>Applied At</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {pendingLeaves.map(leave => (
                    <tr key={leave._id}>
                      <td>{leave.employee?.name}</td>
                      <td>{new Date(leave.startDate).toLocaleDateString()}</td>
                      <td>{new Date(leave.endDate).toLocaleDateString()}</td>
                      <td>{leave.reason}</td>
                      <td>{new Date(leave.appliedAt).toLocaleString()}</td>
                      <td>
                        <button
                          className="la-btn approve"
                          onClick={() => handleDecision(leave._id, 'Approved')}
                        >
                          Approve
                        </button>
                        <button
                          className="la-btn reject"
                          onClick={() => handleDecision(leave._id, 'Rejected')}
                        >
                          Reject
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )
        )}

        {/* History */}
        {activeTab === "history" && (
          historyLeaves.length === 0 ? (
            <div>No leave history found.</div>
          ) : (
            <div className="table">
              <table>
                <thead>
                  <tr>
                    <th>Employee</th>
                    <th>From</th>
                    <th>To</th>
                    <th>Reason</th>
                    <th>Status</th>
                    <th>Action At</th>
                  </tr>
                </thead>
                <tbody>
                  {historyLeaves.map(leave => (
                    <tr key={leave._id}>
                      <td>{leave.employee?.name}</td>
                      <td>{new Date(leave.startDate).toLocaleDateString()}</td>
                      <td>{new Date(leave.endDate).toLocaleDateString()}</td>
                      <td>{leave.reason}</td>
                      <td>
                        <span className={leave.status === "Approved" ? "status approved" : "status rejected"}>
                          {leave.status}
                        </span>
                      </td>
                      <td>{new Date(leave.actionAt).toLocaleString()}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )
        )}
      </div>
    </>
  );
};

export default LeaveApplications;